<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app {
    font-family: 'Microsoft YaHei', 'Avenir', Helvetica, Arial, sans-serif;
  }
html,body,#app{
  width: 100%;
  height: 100%;
  overflow: auto;
  margin: 0;
  padding: 0;
}
.text-success{color: #19be6b}
.text-error{color: #ed4014}
.text-warning{color: #ff9900}
.text-primary{color: #2d8cf0}
  .aRise {
    animation: rise .3s linear;
    -webkit-animation: rise .3s linear;
  }
  @keyframes rise {
    0%   {bottom: -100px}
    100% {bottom: 0}
  }
.main-content{padding-top: 66px;}
</style>



// WEBPACK FOOTER //
// src/App.vue